import React, { useEffect, useMemo, useState } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function EditarRubro({
  initial,
  onClose = () => {},
  onSaved = () => {},
}) {
  // --- ID del registro ---
  const id = useMemo(() => initial?.id ?? null, [initial]);

  // --- Estados de campos ---
  const [codigo, setCodigo] = useState(initial?.codigo || "");
  const [nombre, setNombre] = useState(initial?.nombre || "");

  // --- Estados de UI ---
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // Validación: ambos campos obligatorios
  const isValid = codigo.trim() !== "" && nombre.trim() !== "";

  // Detectar cambios respecto al original
  const changed = useMemo(() => {
    return (
      codigo !== (initial?.codigo || "") ||
      nombre !== (initial?.nombre || "")
    );
  }, [codigo, nombre, initial]);

  // Cerrar con ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const handleSave = async () => {
    if (!id || !changed || !isValid || saving) return;

    setSaving(true);
    setError("");

    try {
      const payload = {
        codigo: codigo.trim(),
        nombre: nombre.trim(),
      };

      const updated = await appFetchJson(apiRoutes.rubros.update(id), {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      onSaved(updated);
      onClose();
    } catch (e) {
      console.error("Error actualizando rubro:", e);
      setError(e?.message || "Error al actualizar el rubro.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        {/* HEADER */}
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Editar Rubro</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* BODY */}
        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">
            Modifique los datos del rubro
          </p>

          {error && (
            <div className="text-red-600 mb-3 font-medium">{error}</div>
          )}

          <div className="form-grid">
            {/* CÓDIGO */}
            <div className="form-row">
              <label className="form-label">Código *</label>
              <input
                type="text"
                className="input"
                value={codigo}
                onChange={(e) => setCodigo(e.target.value)}
                placeholder="Código del rubro"
              />
            </div>

            {/* NOMBRE */}
            <div className="form-row">
              <label className="form-label">Nombre *</label>
              <input
                type="text"
                className="input"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Nombre del rubro"
              />
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar
              label="Guardar"
              isValid={isValid && changed}
              saving={saving}
              onClick={handleSave}
            />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}